export const styles = theme => ({
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
    minHeight: 0,
    margin: '16px -24px 0',
    padding: '0 24px',
  },
  tabRoot: {
    textTransform: 'none',
    minWidth: 50,
    padding: 4,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: 24,
    fontSize: 14,
    minHeight: 0,
    '&:hover': {
      color: '#3a71f1',
      opacity: 1,
    },
    '&:focus': {
      color: '#3a71f1',
    },
    '& span': {
      fontSize: 14,
      lineHeight: '20px',
    },
  },
  tabSelected: {
    color: '#1658F3',
  },
  tabContainer: {
    padding: 0,
  },
  tabsIndicator: {
    backgroundColor: '#1658F3',
  },
  tabPanel: {
    padding: '24px 24px 32px 0',
    boxSizing: 'border-box',
    fontSize: 14,
    height: 'calc(100% - 96px)',
    overflow: 'auto',
    lineHeight: '20px',
    color: '#354052',
    marginRight: -24,
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    padding: '24px 24px 0',
    borderTop: '1px solid #e8e8e8',
    margin: '0 -24px 0',
  },
  form: {
    height: 'calc(100% - 48px)',
  },
})
